module.exports = __webpack_public_path__ + "static/media/logout-white.325d95a2.svg";